<template>
    <div class="container">
     <h1 style="color: #e0e0e0">404 Not Found</h1>
    </div>
</template>

<script>
export default { 
    name: 'NotFoundView',
}
</script>

<style scoped>
.container {
    padding-top: 50px; 
  position: relative;
  min-height: 100vh;
}

</style>
